export default __webpack_public_path__ + "static/media/afr_mobile_1.b6dad8d6.png";